import type { ReactElement } from 'react';
import { useReportWebVitals } from '@/src/homepage/common';
import { HomePageContainer, type HomePageProps } from '@/src/homepage/containers/HomePageContainer';
import { HomepageHead, getHomepageServerSideProps } from '@/src/homepage/components/pages/home';
import { HomepageLayout } from '@/src/homepage/layout/HomepageLayout';
import type { GetLayoutContext } from '@/pages/_app.page';
import { withHomepageDocumentTelemetry } from '@/src/homepage/utils/withHomepageDocumentTelemetry';

export const getServerSideProps = withHomepageDocumentTelemetry(getHomepageServerSideProps());

export function Home(props: HomePageProps) {
    const { serverUrl } = props.env;
    const { stage } = props;

    useReportWebVitals();
    return (
        <>
            <HomepageHead serverUrl={serverUrl} stage={stage} />
            <HomePageContainer {...props} />
        </>
    );
}

Home.getLayout = (page: ReactElement, { route }: GetLayoutContext) => (
    <HomepageLayout page={page} route={route} />
);

export default Home;
